import DeleteIcon from '@mui/icons-material/Delete';
import EditIcon from '@mui/icons-material/Edit';
import { Button, Card, CardActions, CardContent, CardMedia, Typography } from '@mui/material';
import { imageURL } from 'Config/endpoints';
import { deleteBlogSubCategoryFn, getBlogSubCategoryFn } from 'Services/Blog';
import { useMutation, useQuery } from 'react-query';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';

const BlogCategory = () => {
    const navigate = useNavigate();

    const { data: response, refetch } = useQuery({
        queryFn: getBlogSubCategoryFn,
        queryKey: ['get-blog-sub-category'],
    });

    const { mutate: deleteMutate } = useMutation(deleteBlogSubCategoryFn, {
        onSuccess: (response) => {
            toast.success("Category deleted successfully.");
            refetch();
        },
    });

    const handleDelete = (id) => {
        const formData = new FormData();
        formData.append("blog_subcategory_id", id);
        deleteMutate(formData);
    };

    const data = response?.data?.data;

    return (
        <div className="p-4">
            <div className="flex justify-between items-center mb-4">
                <Typography variant="h5" component="h2" className='!text-black font-bold'>
                    Blog Sub Category
                </Typography>
                <Button
                    variant="contained"
                    onClick={() => navigate(`/blog/sub-category/add`)}
                >
                    Add
                </Button>
            </div>

            <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4">
                {data?.map((category) => (
                    <Card key={category?.id} className="bg-white shadow-md rounded-lg">
                        <CardMedia
                            component="img"
                            style={{ height: '200px', objectFit: 'cover' }}
                            image={imageURL(category?.image)}
                            alt={category?.name}
                        />
                        <CardContent>
                            <Typography gutterBottom variant="h6" component="div">
                                {category?.name || "--"}
                            </Typography>
                        </CardContent>
                        <CardActions>
                            <Button
                                size="small"
                                color="primary"
                                onClick={() => navigate(`/blog/sub-category/update/${category?.id}`)}
                            >
                                <EditIcon />
                                Edit
                            </Button>
                            <Button
                                size="small"
                                color='error'
                                onClick={() => handleDelete(category?.id)}
                            >
                                <DeleteIcon />
                                Delete
                            </Button>
                        </CardActions>
                    </Card>
                ))}
            </div>
        </div>
    );
};

export default BlogCategory;
